import React from 'react';
import { Link } from 'react-router-dom';

const Nav = () => {
  return (
    <ul className='mainmenu'>
      <li>
        <Link to='/'>Home</Link>
      </li>
      <li>
        <Link to='/about-us'>About</Link>
      </li>

      <li className='has-droupdown'>
        <Link to='/workshops'>Workshops</Link>
        <ul className='submenu'>
          <li>
            <Link to='/workshops/1'>Natural Construction</Link>
          </li>
          <li>
            <Link to='/workshops/3'>Myoho Valley Reconstruction</Link>
          </li>
          <li>
            <Link to='/workshops/4'>Lets work together</Link>
          </li>
        </ul>
      </li>

      <li>
        <Link to='/contact'>Contact</Link>
      </li>
    </ul>
  );
};
export default Nav;
